// AO 2.0: two account types, Individual and Organization. Accounts not migrated yet still hold a legacy role
// (single_user -> Individual, crew / company -> Organization).
const INDIVIDUAL_ROLE_NAMES = ["individual", "single_user", "user"];
const ORGANIZATION_ROLE_NAMES = ["organization", "crew", "company"];

const normalize = (value) => String(value || "").trim().toLowerCase().replace(/\s+/g, "_");

/** Role name or display name -> "individual" | "organization" | null */
export const accountTypeOf = (value) => {
    const key = normalize(value);
    if (INDIVIDUAL_ROLE_NAMES.includes(key)) return "individual";
    if (ORGANIZATION_ROLE_NAMES.includes(key)) return "organization";
    return null;
};

export const isOrganizationRole = (value) => accountTypeOf(value) === "organization";

/** Label for a role name / display name ("Individual", "Organization"); unknown roles are shown as they are. */
export const accountTypeLabel = (value) => {
    const type = accountTypeOf(value);
    if (type === "individual") return "Individual";
    if (type === "organization") return "Organization";
    return value || "";
};

export const ACCOUNT_TYPE_OPTIONS = ["Individual", "Organization"];
